<h2 mat-dialog-title>{{'printerTableDeletePrinterDialog.headingPrefix' | translate}} {{data.name}} {{'printerTableDeletePrinterDialog.headingSuffix' | translate}}</h2>
<mat-dialog-content>
    <p>{{'printerTableDeletePrinterDialog.questionDelete' | translate}}</p>
    <mat-form-field>
        <mat-label>{{'printerTableDeletePrinterDialog.name' | translate}}</mat-label>
        <input matInput value="{{data.name}}" disabled>
        <!-- <mat-error *ngIf="name.invalid">{{getNameErrorMessage()}}</mat-error> -->
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'printerTableDeletePrinterDialog.description' | translate}}</mat-label>
        <input matInput value="{{data.description}}" disabled>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'printerTableDeletePrinterDialog.location' | translate}}</mat-label>
        <input matInput value="{{data.location}}" disabled>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'printerTableDeletePrinterDialog.connection' | translate}}</mat-label>
        <input matInput value="{{data.deviceURI}}" disabled>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">{{'printerTableDeletePrinterDialog.abort' | translate}}</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="data" cdkFocusInitial>{{'printerTableDeletePrinterDialog.delete' | translate}}</button>
</mat-dialog-actions>